import { makeBreakpoint } from '@utils/css';

const transitionDurationMs = 200;
const mobileFiltersBreakpoint = makeBreakpoint(0, 900);
const header = "_275hn6otue";
const spacer = "_275s6yzlri";
const section = "_275s1oy2556";
const transitionWrapper = "_275t1agbap6";
const mobileActions = "_275m9zxsee";
const chip = "_275c569bk4";

export { chip, header, mobileActions, mobileFiltersBreakpoint, section, spacer, transitionDurationMs, transitionWrapper };
import "./root.style.linaria.module.css";
//# sourceMappingURL=root.style.js.map
